import moment from "moment";
import React, { useContext, useEffect, useState } from 'react';
import { Breadcrumb, Button, OverlayTrigger, Table } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { BiChevronLeft, BiChevronRight, BiPencil, BiSearch } from "react-icons/bi";
import { BsFillEyeFill, BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { FcFinePrint } from 'react-icons/fc';
import { useNavigate, useSearchParams } from "react-router-dom";
import { LoaderContext } from '../../../../App';
import { LS_AUTHORITY_KEY, currentYear, startYear } from '../../../../core/constants/common';
import MaterialIssueService from '../../../../core/service/MaterialIssueService';
import Utils from '../../../../core/utilities/Utils';
import './MaterialityAssessment.scss';


const IssuesVersionsList = ({ t }) => {
    // Hooks must be called unconditionally at the top level
    const { setLoaderDisplay } = useContext(LoaderContext);
    const [versionsList, setVersionsList] = useState([]);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [hasDraft, setHasDraft] = useState(false);
    const lsDat = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
    const companyId = lsDat?.profile?.company?.id;
    const selYear = searchParams.get('year');
    const year = new Date().getFullYear();
    const yearOptions = [];
    for (let i = currentYear; i >= startYear; i--) {
        yearOptions.push(<option value={i} key={i}>{i}</option>);
    }
    const [filter, setFilter] = useState({
        year: selYear ?? `${year}`,
    });
    


    useEffect(() => {
        getVersionsList();
    }, [filter]);

    const getVersionsList = () => {
        setLoaderDisplay(true);
        setHasDraft(false);
        MaterialIssueService.getVersions(companyId, filter.year).then(res => {
            setLoaderDisplay(false);
            if (res.status !== 200) return;
            res.data?.sort((a, b) => b.versionNumber - (a.versionNumber));
            setVersionsList(res.data ?? []);
            res.data.forEach(element => {
                if (element.status == 'DRAFT') {
                    setHasDraft(true);
                    return;
                }
            });
        }).catch(err => {
            setLoaderDisplay(false);
            setHasDraft(true);
        });
    };

    const renderHeader = () => {
        return (
            <>
                <div className="List_header pb-0">
                    <Breadcrumb className='h5'>
                        <Breadcrumb.Item onClick={() => navigate(`/company_admin/dmat/stats`)}>{t("Materiality.label")}</Breadcrumb.Item>
                        <Breadcrumb.Item active>{t("IssuesVersions.label")}</Breadcrumb.Item>
                    </Breadcrumb>
                    <div className="d-flex justify-content-end align-items-center header-actions">

                        {/* <button className="btn  btn-headbtn" >
                            <BsFilter />
                        </button> */}
                        <div className='searchListBox'>
                            <span><BiSearch /></span>
                            <input type='text' className='form-control ' placeholder={t("Search.label")} />
                        </div>
                        <select className="form-select  w-auto" value={filter.year} onChange={(e) => { setFilter({ ...filter, year: e.target.value }); }}>
                            {yearOptions}
                        </select>
                        {/* <Button variant='primary' className='btn' onClick={() => gotoNew()} disabled={hasDraft}> <BiPlus /> {t("New.label")}</Button> */}
                        <OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("NavigateBackAndNext.Stakeholders"))}>
                            <Button variant='secondary' className='back-btn ' onClick={() => navigate(`/company_admin/dmat/stakeholders`)}>
                                <BsChevronLeft /> <span>{t("Back.label")}</span>
                            </Button>
                        </OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("NavigateBackAndNext.MatAssessment"))}>
                            <Button variant='secondary' className='next-btn' onClick={() => navigate(`/company_admin/dmat/matassessments`)}>
                                <span>{t("Next.label")}</span> <BsChevronRight />
                            </Button>
                        </OverlayTrigger>
                    </div>
                </div>
            </>
        );
    };

    const gotoEdit = (data) => {
        navigate("/company_admin/dmat/issues" + `?year=${filter.year}&type=edit`);
    }

    const gotoView = (data) => {
        navigate("/company_admin/dmat/issues" + `?vId=${data.id}&year=${filter.year}&type=view&matType=${data.materialityType}`);
    }

    const gotoIssues = () => {
        navigate("/company_admin/dmat/issues");
    }

    return (
        <div className='ScoreCardbox'>
            {renderHeader()}
            <div className='Stakeholders_table'>
                <Table>
                    <thead>
                        <tr>
                            <th>{t('Name.label')}</th>
                            <th className='text-center'>{t('Type.label')}</th>
                            <th className='text-center'>{t('Version.label')}</th>
                            <th className='text-center'>{t('Year.label')}</th>
                            <th className='text-center'>{t('LastModified.label')}</th>
                            <th className='text-center'>{t('ModifiedBy.label')}</th>
                            <th className='text-center'>{t('Status.label')}</th>
                            <th className='text-center'>{t('Action.label')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {versionsList?.length > 0 ? (
                            versionsList?.map((item, index) => (
                                <tr>
                                    <td>{item?.name}</td>
                                    <td className='text-center'>{item?.materialityType=='SINGLE' ? 'Impact Materiality' : 'Double Materiality'}</td>
                                    <td className='text-center'>{item?.versionNumber}</td>
                                    <td className='text-center'>{item?.year}</td>
                                    <td className='text-center'>{moment(item?.lastModifiedDate).format("MMM DD, YYYY")}</td>
                                    <td className='text-center'>{item?.lastModifiedBy}</td>
                                    <td className='text-center'>
                                        {
                                            item.status == 'DRAFT' &&
                                            <span className="badge bg-badge-Inprogress rounded-pill py-1">{item.status !== null ? Utils.toTitleCase(item.status) : 'NA'}</span>
                                        }
                                        {
                                            item.status == 'FINALIZED' &&
                                            <span className="badge bg-badge-Finalized rounded-pill py-1">{item.status !== null ? Utils.toTitleCase(item.status) : 'NA'}</span>
                                        }
                                    </td>
                                    <td className='text-center'>
                                        {
                                            item.status == 'DRAFT' &&
                                            <OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("Edit.label"))}>
                                                <span className='cursor' onClick={() => gotoEdit(item)}> <BiPencil /></span>
                                            </OverlayTrigger>
                                        }
                                        {
                                            item.status == 'FINALIZED' &&
                                            <OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("View.label"))}>
                                                <span className='cursor' onClick={() => gotoView(item)}> <BsFillEyeFill /></span>
                                            </OverlayTrigger>
                                        }
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="text-center">
                                    <div className="Nodatafound_box">
                                        <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    )
};

export default withTranslation()(IssuesVersionsList);